import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGetUserPermissionsQuery } from './SettingsApi';

export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetUserPermissionsQuery();
  const isSA = data?.user?.isSuperAdmin === true;
  const isAdmin = data?.user?.role?.toLowerCase() === 'admin';
  const location = useLocation();

  if (isLoading) {
    return <div></div>;
  }

  if (!isSA && !isAdmin) {
    return <Navigate to="/admin/activities/error" state={{ from: location }} replace />;
  }

  return <div>{children}</div>;
}
